import genericStore from "../generic_store";

export default {
  namespaced: genericStore.namespaced,
  state: {
    ...genericStore.state,
    endpoint: "reviews",
    object: "review",
    header: [
      { text: "Rating", value: "rating" },
      { text: "Comment", value: "comment" },
      { text: "User", value: "user" },
      { text: "Acciones", value: "actions", sortable: false }
    ]
  },
  mutations: {
    ...genericStore.mutations
  },
  actions: {
    ...genericStore.actions
  },
  getters: {
    ...genericStore.getters
  }
};
